import './Blog.css';
import ICON_MAP from '../../utils/iconMap';

function estimateReadTime(content) {
	const words = content.split(/\s+/).length;
	return Math.max(1, Math.ceil(words / 225));
}

export const BlogCard = ({ post }) => {
	const { meta, content } = post;
	const readTime = estimateReadTime(content);
	const categoryClass = meta.category?.toLowerCase() || 'strategy';
	const dateStr = new Date(meta.date + 'T00:00:00').toLocaleDateString('en-US', {
		year: 'numeric',
		month: 'long',
		day: 'numeric',
	});
	const IconComponent = meta.icon ? ICON_MAP[meta.icon] : null;

	return (
		<div
			className="blog-card"
			onClick={() => { window.location.href = `/blog/${meta.slug}`; }}
			role="article"
		>
			<div className={`blog-card-image ${categoryClass}`}>
				<span className={`blog-card-category-badge ${categoryClass}`}>{meta.category}</span>
				<span className="blog-card-icon">
					{IconComponent ? <IconComponent sx={{ fontSize: 'inherit', color: 'inherit' }} /> : meta.icon || '📝'}
				</span>
			</div>
			<div className="blog-card-content">
				<p className="blog-card-date">{dateStr}</p>
				<h3 className="blog-card-title">{meta.title}</h3>
				<p className="blog-card-excerpt">{meta.description}</p>
				<div className="blog-card-footer">
					<span className="blog-card-read-time">{readTime} min read</span>
					<span className="blog-card-action">
						Read more
						<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
							<path d="M5 12h14M12 5l7 7-7 7" />
						</svg>
					</span>
				</div>
			</div>
		</div>
	);
};
